/**
 * Playlist
 *
 * @copyright 2019 Linguistica 360
 */

import 'nestable2';

import { Script, injector } from '../shared/injector.js';
import { resolveRoot } from '../shared/utils.js';

import $ from 'jquery';


injector.injectClass(class extends Script {
    onLoad() {
        this.id = $('#playlist').data('id');
        this._initRename();

        const $nestable = $('#nestable').nestable();
        $('#playlist form').on('submit', function () {
            const ser = $nestable.nestable('serialize');
            const ids = ser.map((s) => s.id);
            $(this).find('[name=struct]').val(ids.join(','));
        });

        $('.dd').on('click', 'a[data-action=delete]', function () {
            $(this).parents('li').remove();
        });
    }

    _initRename() {
        $('a[data-action=rename]').on('click', this.$wrap(this.rename));
    }

    rename($button) {
        const $span = $button.parent().find('span');
        const name = prompt('Playlist name', $span.html());
        if (!name) return;


        $.ajax({
            url: resolveRoot('ajax/playlist'),
            method: 'POST',
            data: { id: this.id, name },
        }).then(() => {
            $span.html(name);
        });
    }
}, ['playlist']);
